import 'babel-polyfill';
import svg4everybody from 'svg4everybody';
import Pristine from 'pristinejs';
import NiceSelect from '../../node_modules/nice-select2/dist/js/nice-select2.js';



window.W = window;
window.D = document;
window.H = document.querySelector('html');
window.B = document.querySelector('body');
window.Pristine = Pristine;
window.NiceSelect = NiceSelect;